let config = {
    title: '주술: 주술사의 유산',
    email: 'pansj1122@gmail.com',
    policy: 'https://jujutsusorcererslegacy.com/g/privacy_policy.html',
    term: 'https://jujutsusorcererslegacy.com/g/terms.html', 
    copyright: '© 2024 CT INTERNATIONAL TRADE LIMITED',
    introduceTitle: [
       '이것은 단순한 모바일 게임이 아닙니다; 주술회전의 강렬함과 드라마를 담아낸 몰입형 경험입니다. 다른 플레이어와 전투를 벌이거나 스토리 모드에 몰입하든, 당신이 내리는 모든 선택은 주술사로서의 한계를 시험할 것입니다.'
    ],
    introduceText: [
        {
            title: '【좋아하는 캐릭터로 플레이하세요】',
            text: [
                '주술회전의 사랑받는 캐릭터 중에서 선택하세요. 각각의 고유한 저주 기술과 능력을 전투에서 마스터할 수 있습니다.'
            ]
        },
        {
            title: '【실시간 3D 전투】',
            text: [
                '아름답게 렌더링된 3D 환경에서 빠른 속도의 실시간 전투를 경험하세요. AI 상대와 다른 플레이어와의 전투에서 반사 신경과 전술 능력을 시험해 보세요.'
            ]
        },
        {
            title: '【주술사의 유산 아크 기반 스토리 모드】',
            text: [
                '최신 애니메이션과 만화 스토리를 충실히 재현한 매력적인 스토리 모드를 따라가며 주술회전의 세계에 더 깊이 빠져들어 보세요.'
            ]
        },
        {
            title: '【진화하는 규칙의 전략적 게임플레이】',
            text: [
                '끊임없이 변하는 주술사의 유산의 규칙을 탐색하세요. 점수를 얻고, 게임의 역학을 변경하며, 생존하고 승리하기 위해 전략을 조정하세요.'
            ]
        },
        {
            title: '【멋진 애니메이션 스타일의 그래픽】',
            text: [
                '캐릭터 디자인에서 폭발적인 전투 장면에 이르기까지 주술회전 세계를 생동감 있게 재현하는 고품질 비주얼을 즐기세요.'
            ]
        },
        {
            title: '【글로벌 멀티플레이어 이벤트】',
            text: [
                '전 세계의 플레이어들과 이벤트와 순위 전투에서 경쟁하세요. 순위를 높이고 세계에서 가장 강력한 주술사임을 증명해 보세요.'
            ]
        },
    ]
}
export default config;